<template>
  <span class="bar pl-0">
    <span 
      class="bar-name" 
      data-testid="bar-content-name"
    >
      {{ item.name }}
    </span>
    <span 
      class="bar-width d-block" 
      :data-testid="`bar-width-${item.name}`"
      :style="{ width: item.percentage + '%' }" 
    />
  </span>
  <span 
    class="bar-digits pl-0 pr-0" 
    data-testid="bar-content-digits"
  >
    {{ item.count ? item.count : item.percentage + '%' }}
  </span>
</template>
  
<script>
export default {
  name: "BarContent",
  props: {
    item: {
      type: Object,
      default: () => ({}),
    }
  }
};
</script>
  
<style lang="scss" scoped>
.bar {
  position: relative;
  flex: 1 0 auto;
  margin-right: 15px;

  .bar-name {
    position: absolute;
    left: 15px;
    top: 12px;
    text-transform: capitalize;
    color: #243546;
    font-weight: 700;
  }

  .bar-width {
    background-color: #D6E1E9;
    height: 40px;
  }
}

.bar-digits {
  flex: 0 0 16.6666666667%;
  max-width: 16.6666666667%;
  color: #243546;
  font-weight: 700;
  height: 40px;
  padding-top: 12px;
}
</style>
